import { RefObject } from 'react';

import { DEFAULT_ERROR } from '../forms/translationKeys';

export const copySelectorHelper = (
  reactRefObject: RefObject<HTMLFormElement>,
  selectors: string,
  lang: string
) => {
  const notificationElements =
    reactRefObject.current?.querySelectorAll(selectors);
  const notificationText = notificationElements
    ? notificationElements[0]?.innerHTML
    : DEFAULT_ERROR[lang];

  return notificationText;
};
